__turbopack_context__.v({
  "className": "cormorant_garamond_aa95e6ca-module__OSHUbq__className",
});
